export default __webpack_public_path__ + "static/media/levels-icon.879811ad.svg";